import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { AuthenticationService, CommonPlatformService, Platform, PasswordStrengthValidator, ResetPasswordDTO, CommonUtil } from 'psd-common';
import { MustMatch } from '@app/modules/central-login/util/must-match.validator';

@Component({
    selector: 'central-login-new-login',
    templateUrl: 'central-login-new-login.component.html'
})
export class CentralLoginNewLoginComponent implements OnInit {
    public newLoginForm: FormGroup;
    public submitted: boolean = false;
    public tokenId: string;
    public activationToken: string;
    public platformPrefix: string;
    public email: string;
    public currentPlatform: Platform;
    public checkPassword: any = {};
    public submitting: boolean = false;
    public CommonUtil: typeof CommonUtil = CommonUtil;

    constructor(
        @Inject(DOCUMENT) private document: Document,
        private renderer: Renderer2,
        private router: Router,
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private authenticationService: AuthenticationService,
        private platformService: CommonPlatformService
    ) {}

    ngOnInit() {
        this.renderer.addClass(this.document.body, 'login');
        this.route.queryParams.subscribe(_params => {
            this.tokenId = _params.tid;
            this.activationToken = _params.activationToken;
            this.platformPrefix = _params.platform;
            this.email = _params.email;
            if(this.platformPrefix) {
                this.platformService.getExternalPlatformDetails(this.platformPrefix).subscribe(_platform => {
                    this.currentPlatform = _platform;
                });
            }
        });

        this.newLoginForm = this.formBuilder.group(
            {
                password: ['', [Validators.required, Validators.minLength(8), PasswordStrengthValidator()]],
                confirmPassword: ['', Validators.required]
            },
            {
                validator: MustMatch('password', 'confirmPassword')
            }
        );
    }

    get form() {
        return this.newLoginForm.controls;
    }

    save() {
        this.submitted = true;
        this.submitting = true;

        if (this.newLoginForm.invalid || CommonUtil.checkInvalidPassword(this.checkPassword)) {
            this.submitting = false;
            return;
        }

        let json = JSON.parse(JSON.stringify(this.newLoginForm.value, null, 4));
        let resetPasswordDto = new ResetPasswordDTO();
        resetPasswordDto.newPassword = json.password;
        resetPasswordDto.repeatPassword = json.confirmPassword;
        if (this.tokenId) {
            resetPasswordDto.token = this.tokenId;

            this.authenticationService.resetPassword(resetPasswordDto, this.currentPlatform?.id).subscribe(_result => {
                this.submitting = false;
                this.router.navigate(['/central-login/login']); // todo: where do we go? login page? or 'tussenpage' or do we log in the user immediately?
            });
        } else {
            resetPasswordDto.token = this.activationToken;

            this.authenticationService.setPassword(resetPasswordDto, this.currentPlatform?.id, this.email).subscribe(_result => {
                this.submitting = false;
                this.router.navigate(['/central-login/login']); // todo: where do we go? login page? or 'tussenpage' or do we log in the user immediately?
            });
        }


    }

    checkPasswordStrength(event: any) {
        this.checkPassword = CommonUtil.checkPassWordStrength(event.target.value);
    }

    togglePassword(event: any) {
        const password = document.querySelector('#password');
        const type = password.getAttribute('type') === 'password' ? 'text' : 'password';
        password.setAttribute('type', type);
        event.target.classList.toggle('fa-eye-slash');

    }
}
